
import React from 'react';
import { Link } from 'react-router-dom';

const AboutHero = () => {
  return (
    <section className="px-5 pb-16 pt-28 sm:pb-20 sm:pt-32 md:px-8 md:pb-24 md:pt-36">
      <div className="mx-auto w-full max-w-6xl">
        <div className="max-w-5xl">
          <h1 className="mb-7 text-xs font-semibold uppercase text-primary sm:mb-8">About PaperVerse</h1>
          <p className="max-w-5xl text-3xl font-medium leading-tight tracking-normal sm:text-4xl md:text-5xl md:leading-tight lg:text-6xl">
            A paper gets better through writing, evidence, criticism, and revision. <span className="text-primary">PaperVerse brings that work together.</span>
          </p>
          <p className="mt-7 max-w-2xl text-base leading-7 text-muted-foreground sm:mt-8 sm:text-lg sm:leading-8 md:text-xl">
            Work on the manuscript with an AI co-author, check it like a reviewer, and keep every revision under your control.
          </p>
          <div className="mt-7 flex flex-wrap gap-x-2 gap-y-2 text-xs text-muted-foreground sm:mt-10 sm:text-sm">
            <Link to="/privacy" className="underline decoration-border underline-offset-4 transition-colors hover:text-foreground">Private until you publish.</Link>
            <Link to="/eu-processing" className="underline decoration-border underline-offset-4 transition-colors hover:text-foreground">Processed in the EU.</Link>
            <span>You remain responsible for the work.</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
